// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"df0fa020","160":"23f4e524","208":"99d579c3","293":"3a432ba8","453":"46dc3e92","516":"819fc593","519":"04c5c405","917":"becc4016","946":"e6cb90cd"}[chunkId] + ".chunk.js";
};